<template>
    <div :class="{ error: errors.phone, warning: (errors.phone == 'length' || errors.phone == 'checking') }" class="label-field">
        <span class="field-name">{{ label }}</span>
        <div>
            <vue-tel-input v-bind="bindProps" @input="checkNumber" v-model="prepered_data.phone"></vue-tel-input>
        </div>
        <!-- Errors -->
        <span class="label-messages-icons">
            <svg v-if="errors.phone == 'exist' || errors.phone == 'blocked'" class="message-icon error-icon">
                <use xlink:href="/img/front/icons/svgmap.svg#error"/>
            </svg>
            <!-- Warning -->
            <svg v-else-if="errors.phone == 'length'" class="message-icon warning-icon">
                <use xlink:href="/img//front/icons/svgmap.svg#warning"/>
            </svg>
            <!-- Warning -->
            <svg v-else-if="errors.phone == 'checking'" class="message-icon warning-icon">
                <use xlink:href="/img//front/icons/svgmap.svg#warning"/>
            </svg>
            <!-- Error by general checking -->
            <svg v-else class="message-icon error-icon">
                <use xlink:href="/img/front/icons/svgmap.svg#error"/>
            </svg>
        </span>
        <span v-if="errors.phone == 'blocked'" class="label-messages">
            <span class="field-message error-message">
                {{ trans('checkout.user_blocked') }}
            </span>
        </span>
        <span v-if="errors.phone == 'exist'" class="label-messages">
            <span class="field-message error-message">
                {{ trans('checkout.found_user_with_same_phone') }}
            </span>
        </span>
        <span v-if="errors.phone == 'length'" class="label-messages">
            <span class="field-message warning-message">
                {{ trans('checkout.incorrect_length') }}
            </span>
        </span>
        <span v-if="errors.phone == 'checking'" class="label-messages">
            <span class="field-message warning-message">
                {{ trans('general.checking') }}
            </span>
        </span>
    </div>
</template>
<script>
import axios from "axios";
import { VueTelInput } from "vue-tel-input";
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
    mixins: [
    ],
    components: {
        VueTelInput
    },
    props: {
        user: {
            required: false,
            default: null
        },
        phone: {
            required: true
        },
        label: {
            required: false,
            default: null
        },
        full_check: {
            required: false,
            default: true
        },
        first_load: {
            required: false,
            default: true
        }
    },
    model: {
        prop: 'phone',
        event: 'change'
    },
    data() {
        return {
            // Check phone
            prepered_data: {
                phone: this.phone ? '+'+this.phone : null
            },
            // Check phone
            errors: {
                phone: null
            },
            bindProps: {
                mode: "international",
                defaultCountry: 'UA',
                enabledFlags: true,
                validCharactersOnly: true,
                enabledCountryCode: true,
                disabled: false,
                autocomplete: false,
                inputOptions: {
                    //placeholder: this.trans('general.phone'),
                    showDialCode: true
                }
            }
        }
    },
    created() {
        
    },
    beforeMount() {
        
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        // Check phone
        checkNumber(number, isValid, country) {
            if (this.first_load) {
                this.first_load = false;
                return false;
            }

            this.first_load = false;

            if (this.bindProps.disabled) {
                return false;
            }

            // Check chamnges of phone
            if ('+'+this.phone == this.prepered_data.phone.replace(/ /g,'')) {
                this.errors.phone = null;
                this.$emit('phone_error', false);
                return false;
            }

            // Transform phone format   
            number = number ? number.replace(/\D/g, '') : "";

            // Check by component values phone
            if (!isValid.valid) {
                // Set warning of lenght
                this.errors.phone = 'length';
                this.$emit('phone_error', true);
                return false;
            }

            if (this.full_check) {
                this.fullCheck(number, isValid, country);
            } else {
                this.vueCheck(number, isValid, country);
            }  
        },
        fullCheck(number, isValid, country) {
            // Server check
            // Set warning of on check
            this.errors.phone = 'checking';
            this.$emit('phone_error', true);
            
            if (isValid.valid) {
                this.bindProps.disabled = true;
                axios({
                    method: "post",
                    url: window.globalVariables.locale + "/check-phone",
                    data: {
                        phone: number,
                        current_user_id: this.user && this.user.id ? this.user.id : 'null'
                    },
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {
                    console.log(number);
                    // Set error or null if check success
                    this.errors.phone = response.data.error ? response.data.error : null;
                    if (!response.data.error) {
                        // Set phone number
                        this.$emit('change', number);
                        this.$emit('phone_error', false);
                    }
                })
                .catch(error => {
                    console.log(error);
                }).then(() => {
                    this.bindProps.disabled = false;
                });
            }
        },
        vueCheck(number, isValid, country) {
            this.errors.phone = null;
            this.$emit('change', number);
            this.$emit('phone_error', false);
        }
    }
}
</script>